import {put, takeLatest} from "redux-saga/effects";

import {ModalActions} from "@atg-shared/modals-data-access";

import {UPDATE_PUSH_NOTIFICATION_SETTINGS_RESPONSE} from "./personalizationActions";

import type {SagaIterator} from "redux-saga";

export function* updatedPushNotificationSettings(): SagaIterator {
    yield put(ModalActions.closeEditPushNotificationSettingsModal());
}

export default function* personalizationSaga(): SagaIterator {
    yield takeLatest(
        UPDATE_PUSH_NOTIFICATION_SETTINGS_RESPONSE,
        updatedPushNotificationSettings,
    );
}
